var map = {
	"./gradual_change_bg.png": 5993,
	"./icon_address.png": 6600,
	"./icon_cancel.png": 8772,
	"./icon_download.png": 3774,
	"./icon_fold.png": 5371,
	"./icon_jump_left.png": 9192,
	"./icon_jump_right.png": 2778,
	"./icon_mail.png": 1543,
	"./icon_phone.png": 9144,
	"./icon_unfold.png": 7698,
	"./icon_vedio_play.png": 3440,
	"./scroll_top_btn.png": 8404,
	"./wechat-account.png": 7106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;